import { MarginaliaGroup } from "../../../components/ContentBuilder/MarginaliaGroup/MarginaliaGroup";
import { MarginaliaTitle } from "../../../components/ContentBuilder/MarginaliaTitle/MarginaliaTitle";
import { MarginaliaButton } from "../../../components/ContentBuilder/MarginaliaButton/MarginaliaButton";
import { MarginaliaList } from "../../../components/ContentBuilder/MarginaliaList/MarginaliaList";
import { MarginaliaData } from "../../../components/ContentBuilder/ContentBuilder.type";

import { downloadTopicPdf } from "./downloadFile";

// Topic PDF in public/files/pdf; the download button is hidden while this is undefined.
const TOPIC_PDF_FILENAME: string | undefined = "applia-home-appliance-monitor-2025-innovation.pdf";

export const innovationPageMarginalia: MarginaliaData = {
	component: MarginaliaGroup,
	props: {
		children: [
			<MarginaliaTitle key="on-this-page-title" title="On this page" />,
			<MarginaliaList
				key="on-this-page-list"
				items={[
					{
						label: "Investment in R&D by EU Member States",
						scrollTo: "innovation-rd-by-member-states",
					},
					{
						label: "Investment in R&D as fraction of GDP",
						scrollTo: "innovation-rd-vs-gdp-image",
					},
					{
						label: "Patents filed and granted for home appliances",
						scrollTo: "innovation-patents-2",
					},
				]}
			/>,
			<div key="topic-download-spacer" className="mt-3">
				<MarginaliaTitle title="Topic download" />
			</div>,
			...(TOPIC_PDF_FILENAME ? [<MarginaliaButton key="download" variant="download" icon="document" label="Innovation" sublabel="PDF" onClick={() => downloadTopicPdf(TOPIC_PDF_FILENAME)} />] : []),
			<MarginaliaButton key="copy" variant="copy" label="Copy link to this topic" clickedLabel="Link copied" onClick={() => navigator.clipboard.writeText(window.location.href)} />,
		],
	},
};
